import { styled } from 'baseui'
import type { Theme } from 'baseui'

export const PulseToggleButton = styled('span', ({ $theme }: { $theme: Theme }) => ({
  width: '28px',
  height: '28px',
  flexShrink: 0,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderTopLeftRadius: '6px',
  borderTopRightRadius: '6px',
  borderBottomLeftRadius: '6px',
  borderBottomRightRadius: '6px',
  color: $theme.colors.textPulseMuted,
  ':hover': {
    backgroundColor: $theme.colors.bgPulseTrack,
    color: $theme.colors.textPulseStrong,
  },
}))
